import React, { useState, useEffect } from 'react';
import StyledTopBar from './welcomeBarStyles';
import { IoMdCloseCircle } from 'react-icons/io';

interface TopBarProps {}

const TopBar: React.FC<TopBarProps> = ({}) => {
  const [isTopBarVisible, setIsTopBarVisible] = useState(true);

  useEffect(() => {
    // @ts-ignore
    const _isTopbarVisible = JSON.parse(localStorage.getItem('close-topbar'));
    // @ts-ignore
    setIsTopBarVisible(_isTopbarVisible);
  }, []);

  if (isTopBarVisible) return null;

  return (
    <StyledTopBar>
      <div className="topbar">HELLO Avalanche! Welcome to MAXIMUS!</div>

      <IoMdCloseCircle
        onClick={() => {
          // @ts-ignore
          localStorage.setItem('close-topbar', !isTopBarVisible);
          setIsTopBarVisible(!isTopBarVisible);
        }}
        className="close-icon"
        color="#fff"
        size="24"
      />
    </StyledTopBar>
  );
};

export default TopBar;
